import { useMutation } from '@apollo/client';
import {
  SearchRequestInput,
  TravelAuthorizationExportFilterInput,
} from 'common/types/globalTypes';
import React from 'react';
import { FilterArrayType } from 'common/components/Filters';
import { toFilterVariableExport } from './utils';
import {
  AccountingExportCycleFn,
  AccountingExportToCsv,
} from 'common/components/AccountingExportToCsv';
import { toSelection } from 'common/utils/entity';
import {
  TravelAuthorizationExportFilter,
  TravelAuthorizationExportFilterVariables,
} from './__generated__/TravelAuthorizationExportFilter';
import { TravelAuthorizationItem } from '../../list';

import TRAVEL_AUTHORIZATION_EXPORT_FILTER from './TravelAuthorizationExportFilter.graphql';

interface ExportTravelPlansProps {
  selectedRows: TravelAuthorizationItem[];
  isSelectedAll: boolean;
  searchFilters: FilterArrayType[] | undefined;
  searchRequest: SearchRequestInput | null;
  isLinkSearch: boolean;
  isHistorySearch: boolean;
  isSearchAllData: boolean;
  isSigningSearch: boolean;
}

export const ExportTravelPlans: React.FC<ExportTravelPlansProps> = ({
  selectedRows,
  isSelectedAll,
  searchFilters,
  searchRequest,
  isLinkSearch,
  isHistorySearch,
  isSearchAllData,
  isSigningSearch,
}) => {
  const [travelAuthorizationExportFilter] = useMutation<
    TravelAuthorizationExportFilter,
    TravelAuthorizationExportFilterVariables
  >(TRAVEL_AUTHORIZATION_EXPORT_FILTER);

  const getExportCycle: AccountingExportCycleFn = async (
    desc,
    acctPeriod,
    includeDist
  ) => {
    let exportVariable: TravelAuthorizationExportFilterInput = {
      exportDescription: desc,
      corporatePeriodId: acctPeriod,
      isDistributionIncluded: includeDist,
    };

    if (isSelectedAll) {
      const filterVariable = toFilterVariableExport(searchFilters ?? []);
      exportVariable = {
        ...exportVariable,
        searchRequest: searchRequest,
        isLinkSearch,
        isHistorySearch,
        isSearchAllData,
        isSigningSearch,
        ...filterVariable,
      };
    } else if (selectedRows.length > 0) {
      exportVariable = {
        ...exportVariable,
        entityDelete: selectedRows.map(toSelection),
      };
    }

    const { errors, data } = await travelAuthorizationExportFilter({
      variables: { input: exportVariable },
    });

    return {
      id: data?.travelAuthorizationExportFilter?.exportResult
        ?.exportCycles?.[0],
      errors,
    };
  };

  return (
    <AccountingExportToCsv
      isButtonVisible={isSelectedAll || selectedRows.length > 0}
      title="Enter the description and press confirm to download the Travel worksheet."
      getExportCycle={getExportCycle}
    />
  );
};
